//	+-----------------------------------------------+
//	| Cardboard UI base controller object			|
//	+-----------------------------------------------+

/**
 * @file cardboard/baseController.js
 * @module cardboard/baseController
 * @desc This module returns the base controller object, which all controllers inherit from.
 * @author Geoffrey Pursell
 */


define('cardboard/baseController',[
	// app modules
	"cardboard/util"
],
function (Util) {

	console.log("MODULE: cardboard/baseController");

	/**
	 * @constructor
	 * @alias module:cardboard/baseController
	 */
	var BaseController = function () {
		// attach declarative global events
		this.attachGlobalEvents();
	};

	BaseController.prototype = /** @lends module:cardboard/baseController.prototype */ {
		/** global declarative events to listen for; designed to mimic
		 * the behavior of the events hash on Backbone views */
		globalEvents: {},

		/** attach declarative global events */
		attachGlobalEvents: Util.attachGlobalEvents,

		/** provide a way to stop listening to declarative global events */
		stopListeningToGlobalEvents: Util.stopListeningToGlobalEvents
	};

	return BaseController;
});

